var polyline = require('polyline');
var titleTooltipTimeout = [];
var tooltipObjArray = [];
import moment from "moment";
import ApiService from "../services/api";

const helpers = {

	defaultPageSize: 25,

	toQueryString: function (params) {

		var queryString = Object.keys(params).map(function (key) {
			return key + '=' + params[key]
		}).join('&');

		return queryString;

	},
	decodeGooglePolyline: function (path) {
		return polyline.decode(path);
	},
	formatCoordinate(position, longOrLat) {

		let hemisphere = /^[WE]|(?:lon)/i.test(longOrLat) ?
			position < 0 ?
			"O" :
			"E" :
			position < 0 ?
			"S" :
			"N";

		const absDD = Math.abs(position);
		const degrees = truncate(absDD);
		const minutes = truncate((absDD - degrees) * 60);
		const seconds = ((absDD - degrees - minutes / 60) * Math.pow(60, 2)).toFixed(2);

		let dmsArray = [degrees, minutes, seconds, hemisphere];
		return `${dmsArray[0]}°${dmsArray[1]}'${dmsArray[2]}" ${dmsArray[3]}`;
	},

	getIconForVisualizationType(showMap, showHTable, showVTable) {
		var icon = "";

		if (showHTable) icon = "ht_";
		else icon = "no_ht_";

		if (showVTable) icon += "vt_";
		else icon += "no_vt_";

		if (showMap) icon += "m";
		else icon += "no_m";

		return `assets/visualization_type/results_type/${icon}.png`
	},

	getStateMIcon(showMap) {
		var icon = "";

		if (showMap) icon = "m";
		else icon = "no_m";

		return `assets/visualization_type/${icon}.png`
	},
	getStateHTIcon(showHTable) {
		var icon = "";

		if (showHTable) icon = "ht";
		else icon = "no_ht";

		return `assets/visualization_type/${icon}.png`
	},
	getStateVTIcon(showVTable) {
		var icon = "";

		if (showVTable) icon = "vt";
		else icon = "no_vt";

		return `assets/visualization_type/${icon}.png`
	},
	injectTooltip(event, data) {
		var tooltipObj = null;
		var offset = {
			x: 20,
			y: 20
		};

		titleTooltipTimeout.push(setTimeout(() => {
			if (!tooltipObj && event) {
				//create the tooltip object
				tooltipObj = document.createElement("div");
				tooltipObj.setAttribute("class", "map-title-tooltip");
				tooltipObj.innerHTML = data;

				//position it
				tooltipObj.style.position = "fixed";
				tooltipObj.style.top = event.clientY + offset.y + "px";
				tooltipObj.style.left = event.clientX + offset.x + "px";

				//add it to the body
				document.body.appendChild(tooltipObj);

				tooltipObjArray.push(tooltipObj);
			}
		}, 600));
	},
	deleteTooltip() {
		if (titleTooltipTimeout && titleTooltipTimeout.length > 0) {
			titleTooltipTimeout.forEach(tt => {
				clearTimeout(tt);
			});
		}
		if (tooltipObjArray && tooltipObjArray.length > 0) {
			//delete the tooltip if it exists in the DOM
			tooltipObjArray.forEach(t => {
				document.body.removeChild(t);
			});

			tooltipObjArray.splice(0, tooltipObjArray.length);
		}
	},
	chartPdffileName(context, objectName, from, to) {
		return `${objectName}_${context.$options.filters.dateToStringDot(moment(from))}-${context.$options.filters.dateToStringDot(moment(to))}.pdf`;
	},
	getReportName() {
		return ApiService.getViewConfig("fleerun_report");
	},
};

function truncate(n) {
	return n > 0 ? Math.floor(n) : Math.ceil(n);
};


export default helpers;